import { instanceV2 } from "../../../api";
import queryString from "querystring";

const referralCodesApi = {
    listReferralCodes: async (branch_id, params = {}) => {
        const cleaned = {};
        Object.keys(params).forEach((key) => {
            if (params[key] !== null && params[key] !== undefined && params[key] !== "") {
                cleaned[key] = params[key];
            }
        });
        const qs = queryString.stringify(cleaned, '&', '', {
            skipNull: true,
            skipEmptyString: true,
        });
        const url = qs ? `/branches/${branch_id}/referral/codes?${qs}` : `/branches/${branch_id}/referral/codes`;
        return await instanceV2().get(url).then(res => res.data.data);
    },
}

export default referralCodesApi;
